module.exports = __webpack_public_path__ + "static/media/compliance_Earnings.01c59fbf.png";